import LogoURL from '~/assets/logos/logo-small.png';
import './LoadingPage.scss';

const LoadingPage = () => (
  <div id="loading">
    <div className="loading-inner">
      <img src={LogoURL} alt="Meko Trading Logo" />
      <div className="loading-progress" />
    </div>
  </div>
);

export default LoadingPage;
